import React, { useState, useEffect } from "react"
import { Card, CardContent } from "../../../components/ui/card"
import { listOrgOrders } from "../../../utils/orderHelpers"
import { listCourses } from "../../../utils/courseHelpers"

const formatCurrency = (value) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value || 0)

const CommerceProductsPanel = ({ organization }) => {
  const orgId = organization?.orgId
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    setLoading(true)
    Promise.all([listCourses(orgId), listOrgOrders(orgId)]).then(([{ courses }, { orders }]) => {
      const revenueByProduct = {}
      orders?.forEach((o) => {
        if (o?.status !== "paid" || !o?.productId) return
        if (!revenueByProduct[o.productId]) revenueByProduct[o.productId] = { orders: 0, revenue: 0 }
        revenueByProduct[o.productId].orders += 1
        revenueByProduct[o.productId].revenue += o.amount || 0
      })

      const merged =
        courses?.map((c) => ({
          id: c.courseId || c.id,
          title: c.title,
          status: c.status,
          orders: revenueByProduct[c.courseId || c.id]?.orders || 0,
          revenue: revenueByProduct[c.courseId || c.id]?.revenue || 0,
        })) || []

      setProducts(merged.sort((a, b) => b.revenue - a.revenue))
      setLoading(false)
    })
  }, [orgId])

  if (loading) {
    return (
      <div className="space-y-3">
        {Array.from({ length: 6 })?.map((_, i) => <div key={i} className="h-12 rounded-lg bg-muted animate-pulse" />)}
      </div>
    )
  }

  if (!products?.length) {
    return (
      <Card className="shadow-none">
        <CardContent className="p-8 text-center text-muted-foreground">No products yet. Published courses and programs will show up here with sales performance.</CardContent>
      </Card>
    )
  }

  return (
    <Card className="shadow-none">
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-muted-foreground">
              <th className="p-3 font-medium">Product</th>
              <th className="p-3 font-medium">Status</th>
              <th className="p-3 font-medium">Orders</th>
              <th className="p-3 font-medium">Revenue</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id} className="border-b border-border last:border-0 hover:bg-muted/40">
                <td className="p-3 font-medium text-foreground">{p.title}</td>
                <td className="p-3">
                  <span className="rounded-full px-2 py-0.5 text-xs font-medium capitalize bg-muted text-muted-foreground">{p.status}</span>
                </td>
                <td className="p-3">{p.orders}</td>
                <td className="p-3 font-medium">{formatCurrency(p.revenue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  )
}

export default CommerceProductsPanel